import styled from 'styled-components/macro';
import {  NavLink } from 'react-router-dom';
import { FONTS } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';

export const NavItem = styled(NavLink)`
  color: ${COLORS.mainColor};
  ${FONTS.font14}
  
  &.active {
    border-bottom: 1px solid ${COLORS.mainColor};
  }

  &:hover {
    border-bottom: 1px solid ${COLORS.mainColor};
  }
`;
